module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_school_orange-93d64646a3d5fbe12262fad53d813ff0.svg";